<template>
    <div>        
        <div class="row">   
            <b-card-group deck>
                <b-card
                    title="Procesos Creados Últimos 6 meses"
                    img-alt="Image"
                    img-top
                    tag="article"      
                    class="shadow p-3 mb-5 bg-white rounded col-sm-12 col-md-6 col-lg-6"                  
                >
                    <apexchart width="100%" type="bar" :options="options" :series="series"></apexchart>
                </b-card>   
                
                <b-card
                    title="Eventos Creados Últimos 6 meses"
                    img-alt="Image"
                    img-top
                    tag="article"      
                    class="shadow p-3 mb-5 bg-white rounded col-sm-12 col-md-6 col-lg-6"                  
                >
                    <apexchart width="100%" type="line" :options="options" :series="series"></apexchart>
                </b-card>     
            </b-card-group>             
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b-card-group deck>

                <b-card
                    title="Notificaciones Enviadas Por Medios"
                    img-alt="Image"
                    img-top
                    tag="article"      
                    class="shadow p-3 mb-5 bg-white rounded col-sm-12 col-md-6 col-lg-6"                  
                >
                    <apexchart width="100%" type="pie" :options="options_donut" :series="series_donut"></apexchart>
                </b-card>                               
                <b-card                
                    img-top
                    tag="article"      
                    class="shadow p-3 mb-5 bg-white rounded col-sm-12 col-md-6 col-lg-6"                  
                >
                    <apexchart width="100%" type="radialBar" :options="plotOptions_radial" :series="series_radial"></apexchart>
                </b-card>  
            </b-card-group> 
            
            <b-card                
                img-top
                tag="article"      
                class="shadow p-3 mb-5 bg-white rounded col-sm-12 col-md-6 col-lg-6"                  
            >
                <apexchart width="100%" type="area" :options="options_area" :series="options_area.series"></apexchart>
            </b-card>                  
        </div>        
    </div>
</template>
<script>

export default {
    name: 'dashboard',
    data: () => ({        
        options: {
            chart: {
            id: 'vuechart-example'
            },
            xaxis: {
            categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio']
            }
        },
        series: [{
            name: 'series-1',
            data: [130, 140, 145, 150, 149, 160]
        }],
        options_donut: {
            labels: ['Email', 'WhatsApp', 'SMS'],            
        },
        series_donut: [16, 36, 41],
        series_radial: [67],
        colors: ["#20E647"],
        plotOptions_radial: {
            labels: ["Almacenamiento"],
            radialBar: {                
                hollow: {
                    margin: 0,
                    size: "30%"
                },
                track: {
                    dropShadow: {
                    enabled: true,
                    top: 2,
                    left: 0,
                    blur: 4,
                    opacity: 0.15
                    }
                },
                dataLabels: {
                    name: {
                        offsetY: -10,
                        color: "#fff",
                        fontSize: "13px"
                    },
                    value: {
                        color: "#fff",
                        fontSize: "30px",
                        show: true
                    }
                }
            }
        },
        fill: {
            type: "gradient",
            gradient: {
            shade: "dark",
            type: "vertical",
            gradientToColors: ["#87D4F9"],
            stops: [0, 100]
            }
        },
        stroke: {
            lineCap: "round"
        },  
        options_area: {
            series: [{
            name: 'Mes Actual',
            type: 'area',
            data: [44, 55, 31, 47, 31, 43, 26, 41, 31, 47, 33]
            }, {
            name: 'Mes Anterior',
            type: 'line',
            data: [55, 69, 45, 61, 43, 54, 37, 52, 44, 61, 43]
            }],
            chart: {
            height: 350,
            type: 'line',
            },
            stroke: {
            curve: 'smooth'
            },
            fill: {
            type:'solid',
            opacity: [0.35, 1],
            },
            labels: ['Dec 01', 'Dec 02','Dec 03','Dec 04','Dec 05','Dec 06','Dec 07','Dec 08','Dec 09 ','Dec 10','Dec 11'],
            markers: {
            size: 0
            },
            yaxis: [
            {
                title: {
                text: 'Mes Actual',
                },
            },
            {
                opposite: true,
                title: {
                text: 'Mes Anterior',
                },
            },
            ],
            tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (y) {
                if(typeof y !== "undefined") {
                    return  y.toFixed(0) + " points";
                }
                return y;
                }
            }
            }
        }      
    })
}
</script>